import { render } from "./ShadowContainer.vue?vue&type=template&id=ba22ceb6&scoped=true&ts=true"
import script from "./ShadowContainer.vue?vue&type=script&lang=ts"
export * from "./ShadowContainer.vue?vue&type=script&lang=ts"

import "./ShadowContainer.vue?vue&type=style&index=0&id=ba22ceb6&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba22ceb6"]])

export default __exports__